<!--
  //app/components/Shared/TeamsFilter.vue
  -->

<script setup lang="ts">
type Props = {
  teamsOptions: string[];
};
const props = defineProps<Props>();

const selectedTeam = defineModel({ default: 0, required: true, type: Number });
</script>

<template>
  <select
    v-if="teamsOptions && teamsOptions.length"
    v-model="selectedTeam"
    :class="[
      'kql-select text-xs lg:text-sm border-l rounded-lg w-full md:max-w-44',
      { '!bg-primary !text-black': selectedTeam !== 0 },
    ]"
  >
    <option :value="0">
      {{ selectedTeam === 0 ? $t("player.team.word") : $t("general.all.male") }}
    </option>
    <option v-for="team in teamsOptions" :value="team">{{ team }}</option>
  </select>
</template>

<style scoped></style>
